import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText, Button, Stack, Icon, HeaderText,
} from '../../../../../ui';
import { InsightCardProps } from '../types';
import { DismissButton } from './DismissButton';
import TimeToComplete from './TimeToComplete';

export const BASE_ID = 'marketing-tips-marquee-card';
const ElevatePhotosMarqueeCard: React.FC<InsightCardProps> = ({
  id,
  cta,
  clickThroughData,
  analyticsData,
  headline,
  headlineColor,
  bodyText,
  dismissParams,
  onClick,
  onAction,
  firstViewTracking,
  image,
  timeToComplete,
}) => {
  const instanceId = `${BASE_ID}-${id}`;
  const [hasTracked, setHasTracked] = useState(false);

  const visibilityChangeHandler = isVisible => {
    if (hasTracked) {
      return;
    }

    if (isVisible && firstViewTracking) {
      setHasTracked(true);
      firstViewTracking?.();
    }
  };

  return (
    <VisibilitySensor onChange={visibilityChangeHandler}>
      <Box
        padding={4}
        testID={instanceId}
      >
        <Inline
          alignItems="center"
          showBoxShadow
          color={colors.whiteWash}
          minHeight={260}
          justifyContent="space-evenly"
        >
          <Stack
            maxWidth={206}
            paddingX={24}
            justifyContent="center"
            space={8}
            alignItems="flex-start"
            paddingTop={36}
          >
            <Box paddingBottom={16}>
              <TimeToComplete
                testId={`${instanceId}-time-to-complete`}
                time={timeToComplete}
              />
            </Box>
            <HeaderText
              level={2}
              testID={`${instanceId}-headline`}
              color={headlineColor || colors.blackInBlack}
              style={{ width: '100%' }}
            >
              {headline}
            </HeaderText>
            <BodyText
              appearance="medium"
              testID={`${instanceId}-subtext`}
            >
              {bodyText?.map(({ color, text }, index) => (
                <BodyText
                  key={text}
                  appearance="medium"
                  color={color || colors.blackInBlack}
                >
                  {index > 0 && (' ')}
                  {text}
                </BodyText>
              ))}
            </BodyText>
            <Box paddingTop={8}>
              <Button
                size="small"
                onClick={() => onClick(clickThroughData, analyticsData, onAction)}
                testID={`${instanceId}-cta`}
                style={{ borderRadius: '4px', paddingLeft: '8px', paddingRight: '8px' }}
              >
                <BodyText textTransform="none" color={colors.whiteWash} appearance="smaller" weight="bold">
                  {cta}
                </BodyText>
              </Button>
            </Box>
            {dismissParams && (
              <Box paddingTop={20}>
                <DismissButton {...dismissParams} testID={`${instanceId}-dismiss`} />
              </Box>
            )}
          </Stack>
          <Box
            color={colors.lightChill}
            minWidth={129}
            minHeight={260}
            alignItems="center"
            justifyContent="center"
          >
            <Icon uri={image} width={129} height={260} />
          </Box>
        </Inline>
      </Box>
    </VisibilitySensor>
  );
};

export default ElevatePhotosMarqueeCard;
